module.exports = __webpack_public_path__ + "static/img/IPimg1.060e7af3.png";